<template>
  <div class="h-100 w-100">
    <div class="offline" v-if="showDc">
      <i class="menu-icon tf-icons bx bx-wifi-off"></i>
      Desconectado
    </div>
    <router-view />
  </div>
</template>

<style>
</style>

<script>
export default {
  data() {
    return {
      showDc: false,
    };
  },
  mounted() {
    window.addEventListener("offline", (e) => {
      this.showDc = true;
    });

    window.addEventListener("online", (e) => {
      this.showDc = false;
    });
    this.addEvent("logout", this.onLogout);
    setTimeout(() => {
      this.checkSession();
    }, 10);
  },
  methods: {
    onLogout() {
      this.$router.push("/login");
    },
  },
};
</script>
<style>
.offline {
  position: fixed;
  top: 10px;
  background-color: red;
  color: white;
  z-index: 100000;
  padding: 10px;
  border-radius: 10px;
  transform: translateX(calc(50vw + 50%));
}
.md-d-none {
  display: none !important;
}
/* Fix para botão de fechar das modais - sempre dentro do header */
.modal-header {
  display: flex !important;
  align-items: flex-start !important;
  justify-content: space-between !important;
}

.modal-header .btn-close {
  position: relative !important;
  margin: 0 !important;
  padding: 0.5rem !important;
  top: auto !important;
  right: auto !important;
  transform: none !important;
  flex-shrink: 0 !important;
}

@media (max-width: 1199.98px) {
  .offline {
    top: 50px;
    transform: translateX(calc(50vw - 50%));
  }
  .termos-politica {
    margin-top: 50px;
  }
  .md-d-none {
    display: unset !important;
  }
}
</style>
